import React from 'react';
import ReferModel from './ReferModal/ReferModal';
import render from 'ynf-core-engine/render'
import _ from 'lodash';

import initRootStore from '../stores/referRootStore';
import ReferSearch from './ReferSearch/ReferSearch';

import { awaitTo } from '../utils/tools';
import referIndexDB from '../utils/cache';

export default class ReferClass {
  props: any;
  referRootStore: any;
  element: any;

  constructor (props: any) {
    this.props = props
    this.element = this.getPopupContainer()
  }

  init = async () => {
    if (this.referRootStore) return this.referRootStore
    const [data] = await awaitTo(referIndexDB.getRefMeta(this.props, true), undefined, this.props);
    const [store, err] = await awaitTo(initRootStore(data, this.props), undefined, this.props)
    if (store) {
      this.referRootStore= store
      this.props.initRootStore?.(store)
    } else {
      console.error('------init------>', err);
    }
  }

  open = async () => {
    try {
      await this.init()
      this.renderModal()
      this.referRootStore.searchData({ type: 'init', search: true, params: { likeValue: '' } })
      this.referRootStore.referStore.modalVisible = true
    } catch (error) {
      console.error('------open------>', error);
      return this.props.message?.danger('init store Error')
    }
  }

  handleClose = () => {
    this.referRootStore.referStore.modalVisible = false
    this.props.onClose?.();
  }
  
  handleOk = () => {
    this.referRootStore.referStore.modalVisible = false
    this.referRootStore.handleOk()
    this.props.onConfirm?.();
  }
    
  renderModal = () => {
    window.ReactDOM.render(
      <ReferModel
        inputProps={this.props}
        referRootStore={this.referRootStore}
        onOk={() => this.handleOk()}
        onCancel={() => this.handleClose()}
      >
        <div className='refer-model-body'>
          <ReferSearch inputProps={this.props} referRootStore={this.referRootStore}/>
          {render(this.referRootStore.metaDataObj.gridMeta.nfwFeData.children.find((child: any) => child.controlType === 'BillTemplate'), { rootStore: this.referRootStore })}
        </div>
      </ReferModel>,
      this.element
    );
  }

  getPopupContainer () {
    if (this.props.getPopupContainerDom) {
      return typeof this.props.getPopupContainerDom === 'function' ? this.props.getPopupContainerDom() : this.props.getPopupContainerDom
    } else {
      let elementId = document.getElementById('yyrefer-table-column-detail');
      if (!elementId) {
        const container = document.createElement('div')
        container.id = 'yyrefer-table-column-detail'
        elementId = container;
        document.body.append(container)
      }
      return elementId
    }
  }

}

// window.ccccc = new ReferClass({
//   billNo: "ynfshiyong1",
//   bizType: "quote",
//   busiObj: "ynfshiyong1",
//   caption: "币种(系统)",
//   controlType: "ReferInput",
//   dataSourceAlias: "mainEntity",
//   datasource: "currencyTenantVO.name",
//   disabled: undefined,
//   domainKey: "developplatform",
//   fieldidPrefix: "ynfshiyong1|referinput24",
//   isAutoShowName: true,
//   isMasterOrg: false,
//   isNewRefer: false,
//   masterOrgValue: undefined,
//   maxLength: "36",
//   modalMaximize: true,
//   multiple: false,
//   ownDomain: "ucfbasedoc",
//   readOnly: undefined,
//   refCode: "ucfbasedoc.bd_currencytenantref",
//   refEntityUri: "bd.currencytenant.CurrencyTenantVO",
//   refReturn: ['name'],
//   refReturnArr: "{ \"name\": \"formStore,currencyTenantVO_name\" , \"id\": \"formStore,currencyTenantVO\" }",
//   required: false,
//   rowStore: undefined,
//   selectType: "single",
//   serviceCode: undefined,
//   showCEntityKeyFld: false,
//   storeField: "currencyTenantVO",
//   subuiType: "modal",
//   tableStore: undefined,
//   textField: "name",
//   value: {},
//   valueField: "id",
// })
